export default __webpack_public_path__ + "static/media/billing-info-placeholder.06588aef.png";